<template>
  <div class="row">
    <div class="col-lg-12 text-center">
      <h1>Asset Registration Form</h1>
    </div>
    <div class="col-lg-12 group-form">
      <el-table
        :data="tableETD"
        :header-cell-style="{
          background: 'transparent',
          border: 'none',
          borderBottom: '0.5px solid #3d3f51',
        }"
        :cell-style="{
          border: 'none',
          borderBottom: '0.5px solid #3d3f51',
        }"
      >
        <el-table-column
          min-width="100"
          align="center"
          label="Asset No"
          :prop="assetNo"
        >
          <base-input v-model="assetNo"></base-input>
        </el-table-column>
        <el-table-column
          min-width="140"
          align="center"
          label="Asset Description"
          :prop="assetDescription"
          required="true"
        >
          <base-input v-model="assetDescription"></base-input>
        </el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Capitalized Date"
          :prop="capitalizedDate"
        >
          <base-input>
            <el-date-picker
              v-model="capitalizedDate"
              type="date"
            ></el-date-picker>
          </base-input>
        </el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Cost Centre"
          :prop="costCentre"
        >
          <base-input>
            <el-select v-model="costCentre">
              <el-option
                v-for="option in selects.costCentre"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </base-input>
        </el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Condition"
          :prop="condition"
        >
          <base-input>
            <el-select v-model="condition">
              <el-option
                v-for="option in selects.condition"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </base-input>
        </el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Location"
          :prop="location"
        >
          <base-input>
            <el-select v-model="location">
              <el-option
                v-for="option in selects.location"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </base-input>
        </el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Owned By"
          :prop="ownedBy"
        >
          <base-input>
            <el-select v-model="ownedBy">
              <el-option
                v-for="option in selects.owner"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </base-input>
        </el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Last PPM Date"
          :prop="PPMDate"
        >
          <base-input>
            <el-date-picker v-model="PPMDate" type="date"></el-date-picker>
          </base-input>
        </el-table-column>
        <el-table-column
          v-if="condition == 4 || condition == 6"
          min-width="120"
          align="center"
          label="ETD Date"
          :prop="ETDDate"
        >
          <base-input>
            <el-date-picker v-model="ETDDate" type="date"></el-date-picker>
          </base-input>
        </el-table-column>
      </el-table>

      <div class="text-right">
        <base-button @click="submit()" round icon type="green">
          <i class="tim-icons icon-simple-add"></i>
        </base-button>
      </div>
    </div>
    <div class="col-lg-12 group-form">
      <el-table
        :data="table"
        :header-cell-style="{
          background: 'transparent',
          border: 'none',
          borderBottom: '0.5px solid #3d3f51',
        }"
        :cell-style="{
          border: 'none',
          borderBottom: '0.5px solid #3d3f51',
        }"
      >
        <!-- <el-table-column min-width="100" align="center" label="Asset Name" property="assetName"></el-table-column> -->
        <el-table-column
          min-width="100"
          align="center"
          label="Asset No"
          property="assetNo"
        ></el-table-column>
        <el-table-column
          min-width="120"
          align="center"
          label="Asset Description"
          property="assetDescription"
        ></el-table-column>
        <el-table-column
          min-width="130"
          align="center"
          label="Capitalized Date"
          property="capitalizedDate"
        ></el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="Cost Centre"
          property="costCentre"
        ></el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="Condition"
          property="condition"
        ></el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="Location"
          property="location"
        ></el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="Owned By"
          property="ownedBy"
        ></el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="Last PPM Date"
          property="PPMDate"
        ></el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="ETD Date"
          property="ETDDate"
        ></el-table-column>
        <el-table-column :min-width="40" align="right">
          <div slot-scope="props">
            <el-tooltip content="Delete" placement="bottom" effect="light">
              <base-button
                @click.native="handleDelete(props.$index, props.row)"
                class="remove btn-link"
                type="danger"
                size="sm"
                icon
              >
                <i class="tim-icons icon-simple-remove"></i>
              </base-button>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
      <div class="d-flex justify-content-center spinner" v-if="load">
        <circle-8></circle-8>
      </div>
    </div>
    <div class="col-12 text-center">
      <el-link
        href="./img/csv/AssetRegistration.csv"
        class="mt-3"
        type="primary"
        >Download CSV template</el-link
      >
      &nbsp;
      <base-button
        @click="modalsCSV = true"
        class="mt-3"
        native-type="submit"
        type="green"
        simple
        >Import with CSV</base-button
      >&nbsp;
      <base-button class="mt-3" type="primary" @click="send()"
        >Submit</base-button
      >
    </div>
    <modal
      :show.sync="modalsCSV"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h3 slot="header" class="modal-title">Import CSV Form</h3>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 text-center">
            <label id="fileName">{{ fileName }}</label>
            <span class="btn btn-info btn-file">
              <span class="fileinput-new">Choose File</span>
              <input
                accept=".csv"
                type="file"
                class="valid"
                :multiple="false"
                @change="readFile"
              />
            </span>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          @click="submitCSV"
          :disabled="disabled"
          class="mt-3"
          native-type="submit"
          type="success"
          >Submit</base-button
        >&nbsp;&nbsp;&nbsp;
        <base-button
          class="mt-3"
          type="danger"
          @click.native="modalsCSV = false"
          >Cancel</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DatePicker,
  Option,
  Select,
  Link,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { Modal } from "src/components/index";
// require('moment/locale/ms.js');
import "moment/locale/ms";
import { Circle8 } from "vue-loading-spinner";

export default {
  components: {
    Modal,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    [Link.name]: Link,
  },
  data() {
    return {
      load: false,
      table: [],
      fileName: "",
      quantity: "",
      assetName: "",
      assetNo: "",
      assetDescription: "",
      capitalizedDate: "",
      costCentre: "",
      condition: "",
      location: "",
      ownedBy: "",
      PPMDate: "",
      ETDDate: "",
      empId: "",
      disabled: true,
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" },
        ],
        owner: [
          { value: "DHES", label: "DHES" },
          { value: "Contractor", label: "Contractor" },
        ],
        location: [
          { value: "HQ", label: "HQ" },
          { value: "Off HQ", label: "Off HQ" },
        ],
        costCentre: [
          { value: "Cost 1", label: "Cost 1" },
          { value: "Cost 2", label: "Cost 2" },
        ],
      },
      tableDetails: [],
      tableETD: [{}],
      modalsCSV: false,
      dataCSV: [],
      payload: [],
      datatable: [],
    };
  },

  methods: {
    submitCSV() {
      console.log("*****masuk csv*****");
      this.modalsCSV = false;
      this.tableDetails = [];
      console.log(this.dataCSV);
      this.tableDetails = this.dataCSV;
      this.table = this.datatable;
    },
    readFile(ev) {
      this.dataCSV = [];
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (e) => {
        let header;
        let lines = [];
        let csv = e.target.result;
        let allTextLines = csv.split(/\r\n|\n/);
        for (var i = 0; i < allTextLines.length; i++) {
          if (i == 0) {
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }

        // 0: "empID"
        // 1: "assetNo"
        // 2: "assetDescription"
        // 3: "capitalizedDate"
        // 4: "costCentre"
        // 5: "condition"
        // 6: "location"
        // 7: "ownedBy"
        // 8: "ETDDate"
        // 9: "PPMDate"
        // check header
        let flag = 0;
        let payloadtable = {};
        let payload = {};
        if (
          header[0] !== "empID" ||
          header[1] !== "assetNo" ||
          header[2] !== "assetDescription" ||
          header[3] !== "capitalizedDate" ||
          header[4] !== "costCentre" ||
          header[5] !== "condition" ||
          header[6] !== "location" ||
          header[7] !== "ownedBy" ||
          header[8] !== "ETDDate" ||
          header[9] !== "PPMDate"
        ) {
          swal({
            title: "Header Error!",
            html: '<b>Make sure you follow the predefined header as below:</b><img width="100%" height="100%" src="img/asset-csv.PNG">',
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        } else {
          console.log(header);
          lines.pop();
          console.log(lines);
          lines.forEach((line) => {
            console.log(line[0]);

            // check empty values
            let emptyvalue = 0;
            if (line[0] == "" || line[1] == "" || line[2] == "") {
              emptyvalue = 1;
              swal({
                title: "Data Error!",
                text: "Column empID, assetNo and assetDescription cannot be empty!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            // find  status id
            let condition = 0;
            for (var i = 0; i < this.selects.condition.length; i++) {
              if (line[5] == this.selects.condition[i].label) {
                condition = this.selects.condition[i].value;
              }
            }

            if (condition == 0) {
              swal({
                title: "Data Error!",
                text:
                  "Condition " +
                  line[5] +
                  " for asset number " +
                  line[1] +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            // find cost center id
            let costcenter = 0;
            for (var i = 0; i < this.selects.costCentre.length; i++) {
              if (line[4] == this.selects.costCentre[i].label) {
                costcenter = this.selects.costCentre[i].value;
              }
            }

            if (costcenter == 0) {
              swal({
                title: "Data Error!",
                text:
                  "Cost Center " +
                  line[4] +
                  " for asset number " +
                  line[1] +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            // find site idd
            let site = 0;
            for (var i = 0; i < this.selects.location.length; i++) {
              if (line[6] == this.selects.location[i].label) {
                site = this.selects.location[i].value;
              }
            }

            if (site == 0) {
              swal({
                title: "Data Error!",
                text:
                  "Location " +
                  line[6] +
                  " for asset number " +
                  line[1] +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            // find owned by id
            let owned = 0;
            for (var i = 0; i < this.selects.owner.length; i++) {
              // console.log(this.selects.owner[i].value)
              if (line[7] == this.selects.owner[i].label) {
                owned = this.selects.owner[i].value;
              }
            }

            if (owned == 0) {
              swal({
                title: "Data Error!",
                text:
                  "Owner " +
                  line[7] +
                  " for asset number " +
                  line[1] +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            let etdtable1 = moment(line[8], "DD/MM/YYYY");
            let etdtable = etdtable1.format("YYYY-MM-DD");
            let etdsend1 = moment(line[8], "DD/MM/YYYY");
            let etdsend = etdsend1.format("YYYY-MM-DD");
            if (etdtable == "Invalid date") {
              etdtable = "-";
            }
            if (etdsend == "Invalid date") {
              etdsend = "";
            }

            let capDate = moment(line[3], "DD/MM/YYYY");
            let ppmDate = moment(line[9], "DD/MM/YYYY");
            console.log(capDate);

            // check invalid data
            if (
              emptyvalue == 1 ||
              condition == 0 ||
              costcenter == 0 ||
              site == 0 ||
              owned == 0
            ) {
              console.log("TAK MASUK TABLE");
              flag = 1;
            } else {
              // payload nak display table
              payloadtable = {
                EmpID: line[0],
                assetNo: line[1],
                assetDescription: line[2],
                capitalizedDate: capDate.format("YYYY-MM-DD"),
                costCentre: line[4],
                condition: line[5],
                location: line[6],
                ownedBy: line[7],
                ETDDate: etdtable,
                PPMDate: ppmDate.format("YYYY-MM-DD"),
              };

              // payload send backend
              payload = {
                EmpID: line[0],
                assetNo: line[1],
                assetDescription: line[2],
                capitalizedDate: capDate.format("YYYY-MM-DD"),
                costCentre: costcenter,
                condition: condition,
                location: site,
                ownedBy: owned,
                ETDDate: etdsend,
                PPMDate: ppmDate.format("YYYY-MM-DD"),
              };

              this.datatable.push(payloadtable);
              this.dataCSV.push(payload);

              console.log(this.dataCSV);
              this.disabled = false;
            }

            console.log(this.dataCSV);
          });
        }

        if (flag == 1) {
          console.log("jangan hanter");

          this.dataCSV = [];
          this.datatable = [];

          console.log(this.dataCSV);
          console.log(this.datatable);
        } else {
          console.log(this.dataCSV);
          this.fileName = file.name;
        }
      };
    },
    getCost() {
      console.log("*****get cost*****");
      this.selects.costCentre = [];
      this.$http.get(":9996/api/v1/manage/cost").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].CostCenterID,
              label: response[i].CostCenterName,
            };
            this.selects.costCentre.push(obj);
          }
          console.log(this.selects.costCentre);
        }
      });
    },
    getCondition() {
      console.log("*****get condition*****");
      this.selects.condition = [];
      this.$http.get(":9996/api/v1/manage/status").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].StatusID,
              label: response[i].StatusName,
            };
            this.selects.condition.push(obj);
          }
          console.log(this.selects.condition);
        }
      });
    },
    getLocation() {
      console.log("*****get location*****");
      this.selects.location = [];
      this.$http.get(":9996/api/v1/manage/site").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].SiteID,
              label: response[i].SiteName,
            };
            this.selects.location.push(obj);
          }
          console.log(this.selects.location);
        }
      });
    },
    getOwnBy() {
      console.log("*****get own by*****");
      this.selects.owner = [];
      this.$http.get(":9996/api/v1/manage/owner").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].OwnedByID,
              label: response[i].OwnedByName,
            };
            this.selects.owner.push(obj);
          }
          console.log(this.selects.owner);
        }
      });
    },
    send() {
      this.load = true;
      console.log("***** hantar backend *****");
      console.log(this.tableDetails);
      console.log(this.empId);
      let data = [];
      for (var i = 0; i < this.tableDetails.length; i++) {
        let payload = {
          EmpID: this.tableDetails[i].empID,
          AssetNo: this.tableDetails[i].assetNo,
          AssetDesc: this.tableDetails[i].assetDescription,
          CapitalizedDate: this.tableDetails[i].capitalizedDate,
          CostCenterID: this.tableDetails[i].costCentre,
          OwnedByID: this.tableDetails[i].ownedBy,
          StatusID: this.tableDetails[i].condition,
          SiteID: this.tableDetails[i].location,
          LastMaintenanceDate: this.tableDetails[i].PPMDate,
          EtdDate: this.tableDetails[i].ETDDate,
        };
        console.log(payload);
        data.push(payload);
      }

      // send
      this.$http.post(":9996/api/v1/manage/asset", data).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          swal({
            title: "Successful!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.tableDetails = [];
          data = [];
          this.table = [];
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
        this.load = false;
      });
    },
    getToken() {
      console.log(
        JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
      );
      let employee = JSON.parse(
        atob(sessionStorage.getItem("token").split(".")[1])
      );
      this.empId = employee.employeeid;
      console.log(this.empId);
    },
    getRoute() {
      console.log(this.value);
    },
    getPickupFrequency() {
      console.log(this.selects.monday);
    },
    submit() {
      console.log(this.empId);
      if (
        this.assetNo == "" ||
        this.assetDescription == "" ||
        this.capitalizedDate == "" ||
        this.costCentre == "" ||
        this.condition == "" ||
        this.location == "" ||
        this.ownedBy == "" ||
        this.PPMDate == ""
      ) {
        swal({
          title: "Data Error!",
          text: "Form is empy",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        // find name from id
        let costCentre = "";
        for (var i = 0; i < this.selects.costCentre.length; i++) {
          if (this.costCentre == this.selects.costCentre[i].value) {
            costCentre = this.selects.costCentre[i].label;
          }
        }

        let condition = "";
        for (var i = 0; i < this.selects.condition.length; i++) {
          if (this.condition == this.selects.condition[i].value) {
            condition = this.selects.condition[i].label;
          }
        }

        let location = "";
        for (var i = 0; i < this.selects.location.length; i++) {
          if (this.location == this.selects.location[i].value) {
            location = this.selects.location[i].label;
          }
        }

        let ownedby = "";
        for (var i = 0; i < this.selects.owner.length; i++) {
          if (this.ownedBy == this.selects.owner[i].value) {
            ownedby = this.selects.owner[i].label;
          }
        }

        if (this.condition == 4 || this.condition == 6) {
          let obj = {
            empID: this.empId,
            assetNo: this.assetNo,
            assetDescription: this.assetDescription,
            capitalizedDate: moment(this.capitalizedDate).format("YYYY-MM-DD"),
            costCentre: this.costCentre,
            condition: this.condition,
            location: this.location,
            ownedBy: this.ownedBy,
            ETDDate: moment(this.ETDDate).format("YYYY-MM-DD"),
            PPMDate: moment(this.PPMDate).format("YYYY-MM-DD"),
          };
          this.tableDetails.push(obj);

          // for display
          let obj2 = {
            empID: this.empId,
            assetNo: this.assetNo,
            assetDescription: this.assetDescription,
            capitalizedDate: moment(this.capitalizedDate).format("YYYY-MM-DD"),
            costCentre: costCentre,
            condition: condition,
            location: location,
            ownedBy: ownedby,
            ETDDate: moment(this.ETDDate).format("YYYY-MM-DD"),
            PPMDate: moment(this.PPMDate).format("YYYY-MM-DD"),
          };

          this.table.push(obj2);
        } else {
          let obj = {
            // assetName: this.assetName,
            empID: this.empId,
            assetNo: this.assetNo,
            assetDescription: this.assetDescription,
            capitalizedDate: moment(this.capitalizedDate).format("YYYY-MM-DD"),
            costCentre: this.costCentre,
            condition: this.condition,
            location: this.location,
            ownedBy: this.ownedBy,
            ETDDate: "",
            PPMDate: moment(this.PPMDate).format("YYYY-MM-DD"),
          };
          this.tableDetails.push(obj);

          // for display
          let obj2 = {
            // assetName: this.assetName,
            empID: this.empId,
            assetNo: this.assetNo,
            assetDescription: this.assetDescription,
            capitalizedDate: moment(this.capitalizedDate).format("YYYY-MM-DD"),
            costCentre: costCentre,
            condition: condition,
            location: location,
            ownedBy: ownedby,
            ETDDate: "",
            PPMDate: moment(this.PPMDate).format("YYYY-MM-DD"),
          };
          this.table.push(obj2);
        }
        this.assetNo = "";
        this.assetDescription = "";
        this.capitalizedDate = "";
        this.costCentre = "";
        this.condition = "";
        this.location = "";
        this.ownedBy = "";
        this.PPMDate = "";
        this.ETDDate = "";
      }
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.assetNo}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableDetails.findIndex(
        (tableRow) => tableRow.id === row.id
      );

      let indexToDelete2 = this.table.findIndex(
        (tableRow) => tableRow.id === row.id
      );

      if (indexToDelete >= 0) {
        this.tableDetails.splice(indexToDelete, 1);
      }

      if (indexToDelete2 >= 0) {
        this.table.splice(indexToDelete2, 1);
      }
    },
  },

  created() {
    this.getCost();
    this.getCondition();
    this.getLocation();
    this.getOwnBy();
    this.getToken();
  },
};
</script>
<style lang="scss" scoped>
.card {
  background-color: #222a42;
  padding-top: 1%;
  padding-left: 2%;
  padding-right: 2%;
  padding-bottom: 1%;
  box-shadow: 0 4px 8px 0 rgba(26, 26, 26, 0.2),
    0 6px 20px 0 rgba(26, 26, 26, 0.19);
}
.select-day {
  padding-left: 0%;
}
.group-form {
  background-color: #222a42;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
</style>
